import { Component, input, Input } from '@angular/core';
import { ImageField, KeyTextField, NumberField, RichTextField, Slice, TitleField } from '@prismicio/client';
import { Member } from '../team-slice/team-slice.component';
import { JsonPipe } from '@angular/common';
import { AosDirective } from '../../aos/aos.directive';
import { RenderHtmlPipe } from '../render-html/render-html.pipe';
import { HTMLMapSerializer } from '@prismicio/helpers';

@Component({
    selector: 'app-banner-gradient-slice',
    standalone: true,
    imports: [JsonPipe, AosDirective, RenderHtmlPipe],
    templateUrl: './banner-gradient-slice.component.html',
    styleUrl: './banner-gradient-slice.component.scss'
})
export class BannerGradientSliceComponent {
    body = input<BannerGradientSlice>();

    htmlSerializer: HTMLMapSerializer = {
        paragraph: ({ children }) => '<p class="text-size-l mb-0">' + children + '</p>'
    };
}

export type BannerGradientSlice = Slice<
    'bannergradient',
    {
        image: ImageField;
        title: RichTextField;
    },
    never
>;
